module.exports = __webpack_public_path__ + "img/gambling.fc4f8b57.png";